import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used on Leesona 861 FC, 861 Tackified, and 861 Wax machines

export default function BeginBackPressureRow() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <Row className="mb-2">
         <ColPrompt title={"Beginning Back Pressure"} bold={true} description={"kg"} />
         <ColValue size={2}>
            Min:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.begBackPressureMin || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 10, "begBackPressureMin", "float")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 10, "begBackPressureMin")
               }
            />
            {errorDivDefinitions.begBackPressureMin && (
               <ErrorDiv>0.00-10.00 only</ErrorDiv>
            )}
         </ColValue>
         <ColValue size={2}>
            Max:
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson.begBackPressureMax || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 0, 10, "begBackPressureMax", "float")
                     : handleInputRangeChange(defaultOnChangeVal, 0, 10, "begBackPressureMax")
               }
            />
            {errorDivDefinitions.begBackPressureMax && (
               <ErrorDiv>0.00-10.00 only</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}
